"use client";

import { Card } from "react-bootstrap";

// Helpers
const timeToSeconds = (timeString) => {
  if (!timeString) return 0;
  const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

const getProductiveSeconds = (workedTime, breakTime, idleTime) => {
  const worked = timeToSeconds(workedTime);
  const brk = timeToSeconds(breakTime);
  const idle = timeToSeconds(idleTime);
  return Math.max(0, worked - brk - idle);
};

const TotalRevenue = ({ reports = [] }) => {
  const totalWorked = reports.reduce((acc, r) => acc + timeToSeconds(r.workedHours), 0);
  const totalProductive = reports.reduce(
    (acc, r) => acc + getProductiveSeconds(r.workedHours, r.breakTime, r.idleTime),
    0
  );

  const productivity = totalWorked > 0 ? Math.round((totalProductive / totalWorked) * 100) : 0;

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <span>Productivity %</span>

        <h3 className="mb-0 fs-20">{productivity}%</h3>

        <div className="py-3">
          <div className="wh-77 lh-97 text-center m-auto bg-danger bg-opacity-25 rounded-circle">
            <span className="material-symbols-outlined fs-32 text-danger">
              payments
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TotalRevenue;
